import { formatDateString } from "./formatDateString";

export function formatDateTime(
    date: Date,
    { seconds }: { seconds?: boolean } = {
        seconds: true,
    },
): string {
    return `${formatDateString(date, "MMM d, yyyy")} ${formatDateString(
        date,
        `h:mm${seconds ? ":ss" : ""} a`,
    ).toLocaleLowerCase()}`;
}
